import html2canvas from 'html2canvas';

// Render a detached snapshot inside its own print-sized context. The live editor
// may repaginate while html2canvas awaits fonts/images; never capture that moving tree.
export function snapshotPages(pages){
 return [...pages].map(page=>{const workspace=page.closest('.worksheet-workspace');return {element:page.cloneNode(true),width:page.offsetWidth||794,font:getComputedStyle(page).font,style:workspace?.getAttribute('data-style'),layout:workspace?.getAttribute('data-layout'),working:workspace?.getAttribute('data-working')};});
}
export async function capturePage(page,options={}){
 const frozen=page.element?page:snapshotPages([page])[0];
 const stage=document.createElement('div');stage.className='worksheet-workspace ProseMirror';
 if(frozen.style)stage.setAttribute('data-style',frozen.style);
 if(frozen.layout)stage.setAttribute('data-layout',frozen.layout);if(frozen.working)stage.setAttribute('data-working',frozen.working);
 Object.assign(stage.style,{position:'fixed',left:'0',top:'0',width:`${frozen.width}px`,padding:'0',margin:'0',zIndex:'-2147483647',pointerEvents:'none',font:frozen.font});
 const snapshot=frozen.element;Object.assign(snapshot.style,{margin:'0',zoom:'1',transform:'none'});stage.appendChild(snapshot);document.body.appendChild(stage);
 try{return await html2canvas(snapshot,{...options,scrollX:0,scrollY:0});}
 finally{stage.remove();}
}
